import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStoreState } from 'easy-peasy';

// PURPOSE: Render an individual user as a table row
//          Called by UserFeed.js

const UsersList = ({ user, initialUserId }) => {
    
    const navigate = useNavigate();
    const [disable, setDisable] = useState(false)
    const Token = useStoreState((state) => state.Token)

    const CallUserEdit = () => {
        // Send the user state as a parameter to useredit
        navigate('/useredit', { state: { user: user }})
    }

    const CallUserModules = () => {
        // Send the user state as a parameter to userModules
        navigate('/usermodules', { state: { user: user } })
    }

    let uid = user[0]
    let ulastname = user[1]
    let ufirstname = user[2]
    let uemail = user[3]
    let uphone = user[4]
    let ustatus = user[5]
    let lid = Token.login_id

    useEffect(() => {
        if (user[5].toUpperCase() === 'PENDING' || lid === user[0] || user[0] === initialUserId) { setDisable(true) }
    },[])

    return (
        <>
            <tr className='userRow'>
                <td hidden>{uid}</td>
                <td>{ulastname}</td>
                <td>{ufirstname}</td>
                <td>{uemail}</td>
                <td>{uphone}</td>
                <td>{ustatus}</td>
                <td><button
                    className='tblBtn'
                    type='button'
                    disabled={disable}
                    onClick={() => CallUserEdit()}
                >Edit</button></td>
                <td><button
                    className='tblBtn'
                    type='button'
                    disabled={disable}
                    onClick={() => CallUserModules()}
                >Modules</button></td>
            </tr>
        </>
    )
}

export default UsersList